import {
  RecoverpasswordSuccessAction,
  RecoverpasswordErrorAction,
  ForgotTriggerAction,
  ForgotSuccessAction,
  ForgotErrorAction,
  EmptyAction,
  LoginTriggerAction,
  TwoFactTriggerAction,
  LoginRequestAction,
  TwoFactRequestAction,
  LoginSuccessAction,
  TwoFactSuccessAction,
  LoginFailureAction,
  TwoFactFailureAction,
  LoginFulfillAction,
  TwoFactFulfillAction,
  LogoutTriggerAction,
  LogoutRequestAction,
  LogoutSuccessAction,
  LogoutFailureAction,
  LogoutFulfillAction,
  SetSessionTriggerAction,
  SetSessionRequestAction,
  SetSessionSuccessAction,
  SetSessionFailureAction,
  SetSessionFulfillAction,
  UserTypes
} from '../actions'

type UserAction = SetSessionTriggerAction
  | SetSessionRequestAction
  | SetSessionSuccessAction
  | SetSessionFailureAction
  | SetSessionFulfillAction
  | LoginTriggerAction
  | TwoFactTriggerAction
  | LoginRequestAction
  | TwoFactRequestAction
  | LoginSuccessAction
  | TwoFactSuccessAction
  | LoginFailureAction
  | TwoFactFailureAction
  | LoginFulfillAction
  | TwoFactFulfillAction
  | LogoutTriggerAction
  | LogoutRequestAction
  | LogoutSuccessAction
  | LogoutFailureAction
  | LogoutFulfillAction
  | EmptyAction
  | ForgotTriggerAction
  | ForgotSuccessAction
  | ForgotErrorAction
  | RecoverpasswordErrorAction
  | RecoverpasswordSuccessAction

export interface UserState {
  readonly error: string;
  readonly loading: boolean;
  readonly session: {
    readonly id?: number;
    readonly email?: string;
    readonly first_name?: string;
    readonly surname?: string;
    readonly agent_admin?: boolean;
  };
  readonly user: {};
  readonly forgotStatus?: boolean;
  readonly recoverSuccess?: boolean;
}

export const USER_INITIAL_STATE: UserState = {
  error: '',
  loading: false,
  session: {},
  user: {},
  forgotStatus: false,
  recoverSuccess: false,
}

export default (state: UserState = USER_INITIAL_STATE, action: UserAction): UserState => {
  switch (action.type) {
    case UserTypes.FORGOT_SUCCESS:
      return { ...state, forgotStatus: true }
    case UserTypes.FORGOT_ERROR:
      return { ...state, error: 'Something went wrong.' }
    case UserTypes.SET_SESSION_TRIGGER:
    case UserTypes.SET_SESSION_REQUEST: // No _TRIGGER for SET_SESSION so use _REQUEST in this instance
    case UserTypes.LOGIN_TRIGGER:
    case UserTypes.TWO_FACT_TRIGGER:
    case UserTypes.LOGOUT_TRIGGER:
      return { ...state, loading: true }
    case UserTypes.SET_SESSION_SUCCESS:
      return { ...state, session: action.payload.user }
    case UserTypes.LOGIN_SUCCESS:
    case UserTypes.TWO_FACT_SUCCESS:
      return { ...state, user: action.payload }
    case UserTypes.LOGOUT_SUCCESS:
      return { ...state, session: {}, user: {} }
    case UserTypes.LOGIN_FAILURE:
    case UserTypes.LOGOUT_FAILURE:
    case UserTypes.SET_SESSION_FAILURE:
    case UserTypes.TWO_FACT_FAILURE:
      return { ...state, error: action.payload.message }
    case UserTypes.LOGIN_FULFILL:
    case UserTypes.LOGOUT_FULFILL:
    case UserTypes.SET_SESSION_FULFILL:
    case UserTypes.TWO_FACT_FULFILL:
      return { ...state, loading: false }
    case UserTypes.FETCH_RECOVERPASSWORD_REJECTED:
      return { ...state, error: action.payload._data }
    case UserTypes.FETCH_RECOVERPASSWORD_FULFILLED:
      return { ...state, recoverSuccess: true }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/user.ts